import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import userSession from 'utils/userSession';

const adminOnly = WrappedComponent => {
    class AdminOnly extends Component {
        render() {
            if(userSession.isDivisionalUser()) {
                return <WrappedComponent {...this.props} />;
            }
            
            return <Redirect to='/unauthorized' />;
        }
    }
    
    return AdminOnly;
}

export default adminOnly;